import { asyncLoader } from './core/AsyncLoader'
import { scrollListener } from './core/ScrollListener'
import { websiteService } from './service/WebsiteService'
import { postWrapper } from './wrapper/PostWrapper'
import { loaderComponent } from './components/LoaderComponent'

window.addEventListener('DOMContentLoaded', async () => {
	const NUMBER_OF_LOAD_POSTS_PER_QUERY = 5
	const GROUP_AND_WRAP_POST_PER = false
	const postsContainer = document.querySelector('.blog-content')
	const loaderContainer = document.querySelector('#blog-loader-container')
	const metaActivCategory = document.querySelector('[data-blog-activ-categroy]')
	const activCategory = metaActivCategory.dataset.blogActivCategroy
	const metaBaseUrl = document.querySelector('[data-base-url]')
	const baseUrl = metaBaseUrl.dataset.baseUrl

	scrollListener.setContainer(postsContainer)
	loaderComponent.setContainer(loaderContainer)

	postWrapper
		.setContainer(postsContainer)
		.setPostsPerGroup(GROUP_AND_WRAP_POST_PER)

	websiteService
		.setBaseUrl(baseUrl)
		.setCounter(NUMBER_OF_LOAD_POSTS_PER_QUERY)

	await asyncLoader
		.setActiveCategoryId(activCategory)
		.setWebsiteService(websiteService)
		.loadMorePosts()

	scrollListener.addListener()
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/script.js